export const FEEDBACK_MODAL_REDESIGN_OPT_OUT = 'FEEDBACK_MODAL_REDESIGN_OPT_OUT';
export const FEEDBACK_MODAL_REDESIGN_GENERAL_FEEDBACK = 'FEEDBACK_MODAL_REDESIGN_GENERAL_FEEDBACK';
export const FEEDBACK_MODAL_REDESIGN_TRELLIS_FEEDBACK = 'FEEDBACK_MODAL_REDESIGN_TRELLIS_FEEDBACK';
export let FeedbackStepTypes;
(function (FeedbackStepTypes) {
  FeedbackStepTypes["rating"] = "rating";
  FeedbackStepTypes["feedback"] = "feedback";
  FeedbackStepTypes["complete"] = "complete";
})(FeedbackStepTypes || (FeedbackStepTypes = {}));